import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/search/promo-profile-background.webp")